/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const CvSearchStepNameDto = {
    DictMap: 'DICT_MAP',
    Enrichment: 'ENRICHMENT',
    HybridSearch: 'HYBRID_SEARCH',
    JdAnalysis: 'JD_ANALYSIS',
    LlmExtract: 'LLM_EXTRACT',
    Persist: 'PERSIST',
    Rerank: 'RERANK',
    RrfFusion: 'RRF_FUSION',
    StructuralFilter: 'STRUCTURAL_FILTER',
} as const;

export type CvSearchStepNameDto = typeof CvSearchStepNameDto[keyof typeof CvSearchStepNameDto];



